import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubscriptionResponse } from 'src/app/components/shell/subscription.service';

import { UICallLogEvent } from '../../models/call-history.model';

@Component({
  selector: 'app-call-log-details',
  templateUrl: './call-log-details.component.html',
  styleUrls: ['./call-log-details.component.scss'],
})
export class CallLogDetailsComponent implements OnInit {
  @Input() open = false;
  @Input() aiAssistant: string;
  @Input() subscription: SubscriptionResponse;
  @Input() set callItem(value: UICallLogEvent) {
    if (value) {
      this._callItem = value;
      if (this._callItem.webhooks?.length > 0) {
        if (!this.TABS.includes('webhooks')) {
          this.TABS.push('webhooks');
        }
      }
      if (this._callItem?.sms?.length > 0) {
        if (!this.TABS.includes('sms')) {
          this.TABS.push('sms');
        }
      }
      this.addMediaTabs();
    }
  }

  get callItem(): UICallLogEvent {
    return this._callItem;
  }

  @Output() closing: EventEmitter<void> = new EventEmitter();

  public _callItem: UICallLogEvent;
  public TABS: string[] = ['details'];
  public tab = 'details';
  public mediaTab = 'recording';
  public MEDIA_TABS = [];

  ngOnInit(): void {
    if (this.aiAssistant !== 'none') {
      this.TABS.push('ai');
    }
  }

  private addMediaTab(label: string, condition: boolean): void {
    this.MEDIA_TABS.push({
      label: label,
      disabled: !condition,
    });
  }

  private addMediaTabs(): void {
    this.MEDIA_TABS = [];
    this.addMediaTab('recording', this.callItem.recorded);
    this.addMediaTab('voicemail', this.callItem.voicemail);
    this.MEDIA_TABS.sort((a, b) => (a.disabled === b.disabled ? 0 : a.disabled ? 1 : -1));
    this.mediaTab = this.MEDIA_TABS.find((t) => !t.disabled)?.label;
  }

  public close(): void {
    this.open = false;
    this.closing.emit();
  }
}
